import styled from 'styled-components';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 243px;
  border-radius: 4px;
  background-color: var(--mantine-color-body);
  border: 1px solid var(--mantine-color-default-border);
  padding: 8px;
  box-shadow:
    0 7px 7px -5px rgba(0, 0, 0, 0.04),
    0 0 16px 2px rgba(0, 0, 0, 0.1),
    0 0 3px 0 rgba(0, 0, 0, 0.05);

  .title {
    font-size: 14px;
    line-height: 140%;
    font-weight: 600;
    color: var(--mantine-color-text);
    padding: 8px;
    padding-top: 0px;
  }

  .switch-box {
    background-color: var(--mantine-color-body);
    border-radius: 8px;
    padding: 8px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .options-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .divider {
    border: 1px solid var(--mantine-color-default-border);
    margin: 20px 0px 0px 0px;
    width: 100%;
  }

  .switch-button-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 8px;
    padding-top: 0;
  }

  .switch-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 24px;
    gap: 8px;
    padding: 13px;
    border: none;
    border-radius: 4px;
    background-color: ${({ disabled }) => (disabled ? '#E9ECEF' : '#228BE6')};
    color: ${({ disabled }) => (disabled ? '#ADB5BD' : '#FFFFFF')};
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;

    &:hover {
      box-shadow: none;
    }
  }

  .settings-button {
    display: flex;
    width: fit-content;
    justify-content: start;
    align-items: center;
    text-decoration: none;
    color: var(--mantine-color-text);
    gap: 4px;
    border-radius: 10px;
    padding: 8px;
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
    transition: color 300ms ease;

    &:hover {
      color: var(--mantine-color-text);
    }
  }

  .menu-list {
    background-color: var(--mantine-color-body);
    border-radius: 8px;
    padding: 8px;

    .list-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
      border: none;
      color: var(--mantine-color-text);
      font-size: 14px;
      line-height: 140%;
      font-weight: 400;
      text-align: left;
      transition: color 300ms ease;
      background-color: transparent;
      padding: 8px;

      &:hover {
        box-shadow: none;
      }
    }
  }
`;

export const Option = styled.button`
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 36px;
  border-radius: 8px;

  &:hover {
    background-color: ${({ active }) => (active ? 'var(--mantine-color-body)' : '#E7F5FF')};
  }
  .company-name {
    color: #101113;
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
  }
`;
